$(document).ready(function() {
const params = new URLSearchParams(window.location.search);
const purchaseOption = params.get('purchaseoption');
 
if (purchaseOption === 'onetime') {
  $('.tabs').children('.tb').removeClass('active');
  $('.tabs').find('.tb').eq(1).addClass('active');
}

  
    var od_variantdata = $('.oddit_product').data('productvariants');
    $.each(od_variantdata, function(index, val) {
         /* iterate through array or object */
        //console.log('ID: ', val);
    });
  
  /** Flavour Offer Part Click Option functionality **/
setTimeout(function() {
    var flavourstatus = $('.oddit_status').data('flavourstatus');
    if (!flavourstatus) {
      var od_variantdata = $('.oddit_product').data('productvariants');
      var od_productDiscount = $('.oddit_product').data('discount');
      var od_producthandle = $('.oddit_status').data('producthandle');
      var od_filter = '';
      var VariantsInfo = getVariantsInfo(od_variantdata, od_productDiscount, od_filter, od_producthandle);

     
      //console.log('Non Flavourd Variants Info',VariantsInfo);
      if (typeof VariantsInfo[0] != "undefined")
      {
      $('.offer-part.op1').attr('data-sellingplan', VariantsInfo[0].sellingplan);
      $('.offer-part.op1').attr('data-variationid', VariantsInfo[0].id);
      $('.offer-part.op1').attr('data-total', JSON.stringify(VariantsInfo[0]));
      
      }
      if (typeof VariantsInfo[1] != "undefined")
      {
      $('.offer-part.op2').attr('data-sellingplan', VariantsInfo[1].sellingplan);
      $('.offer-part.op2').attr('data-variationid', VariantsInfo[1].id);
      $('.offer-part.op2').attr('data-total', JSON.stringify(VariantsInfo[1]));
      }
      if (typeof VariantsInfo[2] != "undefined")
      {
      $('.offer-part.op3').attr('data-sellingplan', VariantsInfo[2].sellingplan);
      $('.offer-part.op3').attr('data-variationid', VariantsInfo[2].id);
      $('.offer-part.op3').attr('data-total', JSON.stringify(VariantsInfo[2]));
      }
    }
var url = window.location.href;
var arguments = url.split('?').pop().split('=').pop();

var urli = new URL(window.location.href);
var params = new URLSearchParams(urli.search);
var varianti = params.get('variant');




  
  if (localStorage.getItem("optionsel")) {
 var getlo = localStorage.getItem("optionsel");
  }
  
var pronames = $.trim($('.pr_name').html());
if(pronames == 'Glow Powder Marine Collagen Drink' || pronames == 'Multivitamin For Men and Women Delayed Release'  ){
$(document).ready(function() {

  // 1. Get the current variant ID from the URL query string.

  var params = new URLSearchParams(window.location.search);

  var currentVariantId = params.get('variant'); // e.g., "39545378111566"
 
  if (currentVariantId) {

    // -------------------------------------------

    // First, handle the .dv element:

    // -------------------------------------------

    // Get the JSON string from the product container and parse it.

    var $productDiv = $('.rgt_col.info.oddit_product');

    var variantsData = $productDiv.attr('data-productvariants');
 
    try {

      var variants = JSON.parse(variantsData);

    } catch (e) {

      console.error("Error parsing variants JSON:", e);

      return;

    }
 
    // Find the variant object matching the current variant ID.

    var matchedVariant = variants.find(function(variant) {

      return variant.id == currentVariantId;

    });
 
    if (matchedVariant) {

      // Use a property (for example, option1) from the variant to find the corresponding .dv element.

      var option1Value = matchedVariant.option1; // e.g., "Peach and Pineapple"
 
      // Remove any active class from all .dv elements.

      $('.dv.active').removeClass('active');
 
      // Find the .dv element whose data-text equals the option1 value.

      var $dvElement = $('.dv').filter(function() {

        return $(this).data('text') === option1Value;

      }).first();
 
      if ($dvElement.length) {

        $dvElement.addClass('active');

        // Trigger a click on the matching .dv element.

        $dvElement.trigger('click');

      } else {

        console.warn("No matching .dv element found for option1 value:", option1Value);

      }
 
      // -------------------------------------------

      // Next, handle the .offer-part element:

      // -------------------------------------------

      // Remove any active class from all .offer-part elements.

      $('.offer-part.active').removeClass('active');
 
      // Find the .offer-part element whose data-variationid matches the current variant ID.

      var $offerPart = $('.offer-part').filter(function() {

        return $(this).attr('data-variationid') === currentVariantId;

      }).first();
 
      if ($offerPart.length) {

        $offerPart.addClass('active');

        // Trigger a click on the matching .offer-part element.

        $offerPart.trigger('click');

      } else {

        console.warn("No matching .offer-part element found for variant ID:", currentVariantId);

      }

    } else {

      console.warn("No matching variant found for variant ID:", currentVariantId);

    }

  }

});

 
//$('.tb.active').trigger('click');
}
  else{
       $('.dv.active').trigger('click');
    $('.offer-part.active').trigger('click');
    $('.tb.active').trigger('click');
  }



 // if((getlo) && (getlo != 'Women')){
 //    $(".dv[data-text='"+getlo+"']").trigger('click');
   
 //  }
 // alert(arguments);
  if(varianti == '44335002059042'){
    $(".dv[data-text='Women']").trigger('click');
  
  }


  if(varianti == '39545378046030'){
    $('.add_to_cart').addClass('disable');
  }
  

  var procomp = $.trim($('.pr_name').html());

  if(procomp == 'Magnesium Complex Delayed Release'){
$('.add_to_cart').addClass('disable');
 $('.add_to_cart').find('span.dd').html('Out Of Stock');

  }


    //if(procomp == 'Probiotics for Her'){
//$('.add_to_cart').addClass('disable');
 //$('.add_to_cart').find('span.dd').html('Out Of Stock');

  //}
  
 // if(getlo){
 //    $(".dv[data-text='"+getlo+"']").trigger('click');
 //  }
  
if(varianti){
 
$(".offer-part[data-variationid='"+arguments+"']").trigger('click');
  
}
 


  
    
}, 10);
$(document).on('click', '.dv', function(event) {

  event.preventDefault();
  /* Act on the event */
  $('.dv').removeClass('active');
  $(this).addClass('active');

    var slidefr = $(this).attr('data-text');
 
  var titlepro = $('.pr_name').html();
  if(titlepro == 'Glow Powder Marine Collagen Drink'){
if(slidefr == 'Lemonn and Mintt'){
  $('.add_to_cart').addClass('disable'); 
  $('.add_to_cart').find('span.dd').html('Out Of Stock');
}
  else{
    $('.add_to_cart').removeClass('disable');
    $('.add_to_cart').find('span.dd').html('Add To Cart');
  }
  }

  if(slidefr == 'Men'){
    
//        $('.add_to_cart').addClass('disable'); 
//  $('.add_to_cart').find('span.dd').html('Out Of Stock');

 $('.hero-banner').slick('slickGoTo', 1);
    console.log('changeme');
  }
  else{
    $('.add_to_cart').removeClass('disable');
    $('.add_to_cart').find('span.dd').html('Add To Cart');
  }
  
  if(slidefr == 'Women'){
   setTimeout(function(){ 
 $('.hero-banner').slick('slickGoTo', 2);
    console.log('changewo');
     }, 500);
  }
 

  
   
  
  
  if(slidefr == 'Mixed'){
  
   $('.hero-banner').slick('slickGoTo', 0);
  } 
  
  $('.dd_lft').find('.lbl').text($(this).data('text'));
  $('.dd_lft').find('.lbl').data('id',$(this).data('id'));
  var od_variantdata = $('.oddit_product').data('productvariants');
  var od_productDiscount = $('.oddit_product').data('discount');
  var od_producthandle = $('.oddit_status').data('producthandle');
  var od_filter = $(this).data('text');
  var VariantsInfo = getVariantsInfo(od_variantdata, od_productDiscount, od_filter, od_producthandle);
  //console.log('Flavourd Variants Info',VariantsInfo);
  $('.offer-part').show();
var purchaseoptiond = $('.tb.active').attr('rel');
  console.log(VariantsInfo);
  if (typeof VariantsInfo[0] != "undefined")
  {
       var titlepro = $('.pr_name').html();
  if(titlepro == 'Glow Powder Marine Collagen Drink'){
   
      if(purchaseoptiond == 'subscription'){
        $('.offer-part.op1').html('<div class="top_main_insupp">Best Deal</div><div class="top_middle_insupp">'+VariantsInfo[0][od_filter].supply+'</div><div class="top_last_insupp">£15.99 / pouch</div>');
   
      }else{

         $('.offer-part.op1').html('<div class="top_main_insupp">Best Deal</div><div class="top_middle_insupp">'+VariantsInfo[0][od_filter].supply+'</div><div class="top_last_insupp">£19.99 / pouch</div>');
  
      }
     
    
  }
    else{
var variantData = VariantsInfo[0][od_filter];
// Extract the number of bottles from the 'supply' field
var supply = parseInt(variantData.supply.split(" ")[0]); // This will extract the number (e.g., '1' from '1 Bottle')
  if(variantData.supply == '6 Bottles'){
   var supif = '';
 }
      else{
        var supif = ''; 
      }
// Calculate the price for one-time purchase and subscription
var otpEachPrice = variantData.price/100; // Price for one-time selection
        var otpEachPrice = (otpEachPrice/ supply).toFixed(2);
var subEachPrice = parseFloat(variantData.sub_price); // Price for subscription selection
   var subprice  = (subEachPrice / supply).toFixed(2);
      if(purchaseoptiond == 'subscription'){
   $('.offer-part.op1').html('<div class="top_main_insupp">Best Deal</div><div class="top_middle_insupp">'+VariantsInfo[0][od_filter].supply+'</div><div class="top_last_insupp">£'+subprice+' / bottle</div>');   
     // $('.offer-part.op3').html(VariantsInfo[0][od_filter].supply);
      }
      else{
          $('.offer-part.op1').html('<div class="top_main_insupp">Best Deal</div><div class="top_middle_insupp">'+VariantsInfo[0][od_filter].supply+'</div><div class="top_last_insupp">£'+otpEachPrice+' / bottle</div>');   
 
      }
      
      
      }
 // $('.offer-part.op1').html(VariantsInfo[0][od_filter].supply);
  $('.offer-part.op1').attr('data-sellingplan', VariantsInfo[0][od_filter].sellingplan);
  $('.offer-part.op1').attr('data-variationid', VariantsInfo[0][od_filter].id);
  $('.offer-part.op1').attr('data-total', JSON.stringify(VariantsInfo[0][od_filter]));
 
  }
  else
  {
    $('.offer-part.op1').hide();
  }
  if (typeof VariantsInfo[1] != "undefined")
  {
    var titlepro = $('.pr_name').html();
  if(titlepro == 'Glow Powder Marine Collagen Drink'){
    if(VariantsInfo[1][od_filter].supply == '6 Week Supply'){
       if(purchaseoptiond == 'subscription'){
            $('.offer-part.op2').html('<div class="top_middle_insupp">'+VariantsInfo[1][od_filter].supply+'</div><div class="top_last_insupp">£19.19 / pouch</div>');
  
       }
      else{
          $('.offer-part.op2').html('<div class="top_middle_insupp">'+VariantsInfo[1][od_filter].supply+'</div><div class="top_last_insupp">£23.99 / pouch</div>');
   
      }
   
    }
  }
    else{

var variantData = VariantsInfo[1][od_filter];
// Extract the number of bottles from the 'supply' field
var supply = parseInt(variantData.supply.split(" ")[0]); // This will extract the number (e.g., '1' from '1 Bottle')
 
// Calculate the price for one-time purchase and subscription
var otpEachPrice = variantData.price/100; // Price for one-time selection
        var otpEachPrice = (otpEachPrice/ supply).toFixed(2);
var subEachPrice = parseFloat(variantData.sub_price); // Price for subscription selection
   var subprice  = (subEachPrice / supply).toFixed(2);
     if(purchaseoptiond == 'subscription'){
   $('.offer-part.op2').html('<div class="top_middle_insupp">'+VariantsInfo[1][od_filter].supply+'</div><div class="top_last_insupp">£'+subprice+' / bottle</div>');   
     // $('.offer-part.op2').html(VariantsInfo[0][od_filter].supply);
      }
      else{
          $('.offer-part.op2').html('<div class="top_middle_insupp">'+VariantsInfo[1][od_filter].supply+'</div><div class="top_last_insupp">£'+otpEachPrice+' / bottle</div>');   
 
      }
     // $('.offer-part.op2').html(VariantsInfo[1][od_filter].supply);
    }
  //$('.offer-part.op2').html(VariantsInfo[1][od_filter].supply);
  $('.offer-part.op2').attr('data-sellingplan', VariantsInfo[1][od_filter].sellingplan);
  $('.offer-part.op2').attr('data-variationid', VariantsInfo[1][od_filter].id);
  $('.offer-part.op2').attr('data-total', JSON.stringify(VariantsInfo[1][od_filter]));
  }
  else
  {
    $('.offer-part.op2').hide();
  }
  if (typeof VariantsInfo[2] != "undefined")
  {
var titlepro = $('.pr_name').html();
  if(titlepro == 'Glow Powder Marine Collagen Drink'){
    
     if(purchaseoptiond == 'subscription'){
          $('.offer-part.op3').html('<div class="top_middle_insupp">'+VariantsInfo[2][od_filter].supply+'</div><div class="top_last_insupp">£21.59 / pouch</div>');
  
      }
      else{
           $('.offer-part.op3').html('<div class="top_middle_insupp">'+VariantsInfo[2][od_filter].supply+'</div><div class="top_last_insupp">£26.99 / pouch</div>');
  
      }
      
   
    
  }
    else{


var variantData = VariantsInfo[2][od_filter];
// Extract the number of bottles from the 'supply' field
var supply = parseInt(variantData.supply.split(" ")[0]); // This will extract the number (e.g., '1' from '1 Bottle')
 if(variantData.supply == '6 Bottles'){
   var supif = '';
 }
      else{
        var supif = ''; 
      }
// Calculate the price for one-time purchase and subscription
var otpEachPrice = variantData.price/100; // Price for one-time selection
   var otpEachPrice = (otpEachPrice/ supply).toFixed(2);     
var subEachPrice = parseFloat(variantData.sub_price); // Price for subscription selection
   var subprice  = (subEachPrice / supply).toFixed(2);
    if(purchaseoptiond == 'subscription'){
   $('.offer-part.op3').html(supif+'<div class="top_middle_insupp">'+VariantsInfo[2][od_filter].supply+'</div><div class="top_last_insupp">£'+subprice+' / bottle</div>');   
     // $('.offer-part.op1').html(VariantsInfo[0][od_filter].supply);
      }
      else{
          $('.offer-part.op3').html(supif+'<div class="top_middle_insupp">'+VariantsInfo[2][od_filter].supply+'</div><div class="top_last_insupp">£'+otpEachPrice+' / bottle</div>');   
 
      }
     // $('.offer-part.op1').html(VariantsInfo[2][od_filter].supply);
    }
  
  $('.offer-part.op3').attr('data-sellingplan', VariantsInfo[2][od_filter].sellingplan);
  $('.offer-part.op3').attr('data-variationid', VariantsInfo[2][od_filter].id);
  $('.offer-part.op3').attr('data-total', JSON.stringify(VariantsInfo[2][od_filter]));
  }
  else
  {
    $('.offer-part.op3').hide();
  }
  if(!$('.offer-part.active').is(":visible"))
  {
     $('.offer-part.op1').trigger('click');
  }
  $('.offer-part.active').trigger('click');
});
/** Week supply Offer Part Click Option functionality **/
$(document).on('click', '.offer-part', function(event) {
  event.preventDefault();
  /* Act on the event */
  $('.offer-part').removeClass('active');
  $(this).addClass('active');
  var offerdata = JSON.parse($(this).attr('data-total'));
  //console.log('offerdata',offerdata);
  //console.log($(this).attr('data-variationid'));
  //console.log(window.location.href.split('?')[0]);
  var variantid = $(this).attr('data-variationid');

  //for mint out of stock
// var slidefr = $('.dv.active').attr('data-text');
  var titlepro = $('.pr_name').html();
  if(titlepro == 'Glow Powder Marine Collagen Drink'){
   if(variantid == '395453780460304' || variantid == '395453780132622' || variantid == '395453779804944' ){
  $('.add_to_cart').addClass('disable');
 $('.add_to_cart').find('span.dd').html('Out Of Stock');  
     
}
  else{
    $('.add_to_cart').removeClass('disable');
    $('.add_to_cart').find('span.dd').html('Add To Cart');
  } 
  }


  
// if (localStorage.getItem("optionsel")) {

//   localStorage.removeItem("mytime");
//       var getvalofsel = $('.dv.active').attr('data-text');
  
//   if(getvalofsel){
//  localStorage.setItem("optionsel", getvalofsel);
//   }
// }
//   else{
//      var getvalofsel = $('.dv.active').attr('data-text');
  
//   if(getvalofsel){
//  localStorage.setItem("optionsel", getvalofsel);
//   }
//   }
  
  window.history.replaceState(null, null, "?variant="+variantid);
  var purchaseoption = $('.tb.active').attr('rel');
  //$('.otp_cross_price').text('£'+parseFloat(offerdata.otp_cross_price).toFixed(2));
  $('.otp_each_price').text('£'+(offerdata.price/100).toString());
  $('.sub_each_price').text('£'+parseFloat(offerdata.sub_price).toFixed(2));
  $('.sub_cross_price').text('£'+(offerdata.price/100).toString());
  //$('.otp_each_price').text('£'+parseFloat(offerdata.otp_each_price).toFixed(2));
  //$('.sub_each_price').text('£'+parseFloat(offerdata.sub_each_price).toFixed(2));
  //$('.sub_cross_price').text('£'+parseFloat(offerdata.sub_cross_price).toFixed(2));
  if(parseFloat(offerdata.otp_cross_price) === 0)
  {
    $('.otp_cross_price').text('');
  }
  var variantprice;
    if (purchaseoption == 'subscription') {
         variantprice =  offerdata.sub_price;
    }
    else if (purchaseoption == 'onetime'){
          variantprice =  (offerdata.price/100).toString();
    }
    variantprice = '£'+variantprice;
    //console.log('variantprice',variantprice);
    $('.totalprice').text(variantprice);

var getlengthfor = $('.ddcont').find('.dv').length;

  if(getlengthfor > 0){
  }
  else{  
 

var od_variantdata = $('.oddit_product').data('productvariants');
  var od_productDiscount = $('.oddit_product').data('discount');
  var od_producthandle = $('.oddit_status').data('producthandle');
 
// Get the title
   var od_filter = '';

  var VariantsInfo = getVariantsInfo(od_variantdata, od_productDiscount, od_filter, od_producthandle);
  //console.log('Flavourd Variants Info',VariantsInfo);
  $('.offer-part').show();
var purchaseoptiond = $('.tb.active').attr('rel');
  console.log(VariantsInfo);
  if (typeof VariantsInfo[0] != "undefined")
  {


var variantData = VariantsInfo[0];
// Extract the number of bottles from the 'supply' field
var supply = parseInt(variantData.supply.split(" ")[0]); // This will extract the number (e.g., '1' from '1 Bottle')
 
// Calculate the price for one-time purchase and subscription
var otpEachPrice = variantData.price/100; // Price for one-time selection
    var otpEachPrice = (otpEachPrice/ supply).toFixed(2);
var subEachPrice = parseFloat(variantData.sub_price); // Price for subscription selection
   var subprice  = (subEachPrice / supply).toFixed(2);
   
if(purchaseoptiond == 'subscription'){
   $('.offer-part.op1').html('<div class="top_main_insupp">Best Deal</div><div class="top_middle_insupp">'+VariantsInfo[0].supply+'</div><div class="top_last_insupp">£'+subprice+' / bottle</div>');   
     // $('.offer-part.op3').html(VariantsInfo[0][od_filter].supply);
  }
  else{
    $('.offer-part.op1').html('<div class="top_main_insupp">Best Deal</div><div class="top_middle_insupp">'+VariantsInfo[0].supply+'</div><div class="top_last_insupp">£'+otpEachPrice+' / bottle</div>');   
   
  }  


    
  }
  else
  {
    $('.offer-part.op1').hide();
  }
  if (typeof VariantsInfo[1] != "undefined")
  {


var variantData = VariantsInfo[1];
// Extract the number of bottles from the 'supply' field
var supply = parseInt(variantData.supply.split(" ")[0]); // This will extract the number (e.g., '1' from '1 Bottle')
 
// Calculate the price for one-time purchase and subscription
var otpEachPrice = variantData.price/100; // Price for one-time selection
var otpEachPrice = (otpEachPrice/ supply).toFixed(2);
    
var subEachPrice = parseFloat(variantData.sub_price); // Price for subscription selection
   var subprice  = (subEachPrice / supply).toFixed(2);
  if(purchaseoptiond == 'subscription'){
   $('.offer-part.op2').html('<div class="top_middle_insupp">'+VariantsInfo[1].supply+'</div><div class="top_last_insupp">£'+subprice+' / bottle</div>');   
     // $('.offer-part.op3').html(VariantsInfo[0][od_filter].supply);
  }
  else{
    $('.offer-part.op2').html('<div class="top_middle_insupp">'+VariantsInfo[1].supply+'</div><div class="top_last_insupp">£'+otpEachPrice+' / bottle</div>');   
   
  }  
  }
  else
  {
    $('.offer-part.op2').hide();
  }
  if (typeof VariantsInfo[2] != "undefined")
  {

   


var variantData = VariantsInfo[2];
// Extract the number of bottles from the 'supply' field
var supply = parseInt(variantData.supply.split(" ")[0]); // This will extract the number (e.g., '1' from '1 Bottle')
 
// Calculate the price for one-time purchase and subscription
var otpEachPrice = variantData.price/100; // Price for one-time selection

var otpEachPrice = (otpEachPrice/ supply).toFixed(2);
      
var subEachPrice = parseFloat(variantData.sub_price);
    //alert(subEachPrice);// Price for subscription selection
   var subprice  = (subEachPrice / supply).toFixed(2);
if(purchaseoptiond == 'subscription'){
   $('.offer-part.op3').html('<div class="top_middle_insupp">'+VariantsInfo[2].supply+'</div><div class="top_last_insupp">£'+subprice+' / bottle</div>');   
     // $('.offer-part.op3').html(VariantsInfo[0][od_filter].supply);
  }
  else{
    $('.offer-part.op3').html('<div class="top_middle_insupp">'+VariantsInfo[2].supply+'</div><div class="top_last_insupp">£'+otpEachPrice+' / bottle</div>');   
   
  }  
  }
  else
  {
    $('.offer-part.op3').hide();
  }


  }
  
  
});
/* Subscription tupe click option functionality*/
$(document).on('click', '.tb', function(event) {
  event.preventDefault();
  /* Act on the event */
  $('.tb').removeClass('active');
  $(this).addClass('active');
  $('.add_to_cart').attr('rel',$(this).attr('rel'));
  $('.offer-part.active').trigger('click');
   var titlepro = $('.pr_name').html();
  if(titlepro == 'Glow Powder Marine Collagen Drink'){
  $('.dv.active').trigger('click');
  }

   if(titlepro == 'Multivitamin For Men and Women Delayed Release'){
  $('.dv.active').trigger('click');
  }
});
/** add to cart button click event **/
$(document).on('click', '.add_to_cart', function(event) {
    event.preventDefault();
    /* Act on the event */
    var sellingplan = $('.offer-part.active').attr('data-sellingplan');
    var variationid = $('.offer-part.active').attr('data-variationid');
    var purchasetype = $(this).attr('rel');
    var payloaddata = {};
    if (purchasetype == 'subscription') {
        payloaddata = {};
        payloaddata = {quantity: 1, id: variationid, properties: {}, selling_plan: sellingplan};
    }
    else if (purchasetype == 'onetime'){
        payloaddata = {};
        payloaddata = {quantity: 1, id: variationid, properties: {}};
    }
    $.ajax({
        url: '/cart/add.js',
        type: 'POST',
        dataType: 'json',
        data: payloaddata,
    })
    .done(function(res) {
        console.log("success");
        //console.log(res);

      if (window.ReChargeCartUpdate) {
      window.ReChargeCartUpdate();
    } else if (window.RECHARGE_CART) {
      window.RECHARGE_CART.updateCart();
    }
     // window.ReCharge.SmartCart.addProduct(productData);

       if (purchasetype == 'onetime'){
     
      // $('#confirmation-message').addClass("show");
       // $('#confirmation-message').removeClass("hidden");
   
      }
     //window.Rebuy.SmartCart.show(); 
    })
    .fail(function(res) {
        console.log("error");
        console.log(res);
    })
    .always(function(res) {
        console.log("complete");
    //window.location.href= "https://rockandroses.life/cart";
        //console.log(res);
    });
    //console.log('payloaddata',payloaddata);
});
/*Find lowest price available*/
function getLowestItem(od_variantdata, filter){
    var max = Infinity;
    var titleValue;
    var itemValue;
    $.each(od_variantdata, function(index, val) {
         /* iterate through array or object */
        titleValue = val.title.match(/\d+/)[0];
        titleValue = parseInt(titleValue);
        if (val[filter] < max) {
            max = val.price;
            itemValue = (max/titleValue)/100;
            itemValue = itemValue.toFixed(3);
        }
    });
    return itemValue;
}
function getVariantsInfo(od_variantdata, od_productDiscount, od_filter, od_producthandle) {
    var supplydata = [];
    var isSubscriptionEnable  = true;
    var sub_price = 0;
    var subID;
    var lowestprice = getLowestItem(od_variantdata, 'price');
    var variantTitleValue;
    var otp_each_price;
    var sub_each_price;
    var sub_cross_price;
    var otp_cross_price;
    var productDiscount = 0.00;
    if(od_productDiscount.length > 0)
    {
      productDiscount = parseFloat(od_productDiscount).toFixed(2);
    }
    
    console.log('productDiscount', (productDiscount));
    //console.log('od_variantdata',typeof od_productDiscount);
    //console.log('Lowestprice',lowestprice);
    $.each(od_variantdata, function(index, val) {
             /* iterate through array or object */
        var flavour = [];
        var sellingplan;
        variantTitleValue = val.title.match(/\d+/)[0];
        variantTitleValue = parseInt(variantTitleValue);
        var otp_total = Math.round(lowestprice * variantTitleValue);
        otp_cross_price = Math.round(otp_total-(val.price/100));
        switch (od_producthandle) {
          case 'glow-powder':
              otp_each_price = ((val.price/100)/(variantTitleValue /2));
            break;
          case 'multivitamin':
              otp_each_price = ((val.price/100)/(variantTitleValue));
            break;
          case 'biotin':
              otp_each_price = ((val.price/100)/(variantTitleValue));
            break;
          default:
                  otp_each_price = ((val.price/100)/(variantTitleValue));
        }
        //console.log(index+' - '+variantTitleValue,(val.price/100));
        if(isSubscriptionEnable)
        {
            variantprice = parseFloat(val.price/100);
            //sub_price = variantprice - ( variantprice / 10 );
            if(od_productDiscount.length > 0)
            {
              sub_price = variantprice - ((productDiscount * variantprice) / 100);
              sub_price_view = sub_price.toFixed(2);
            }
            else
            {
              sub_price = variantprice;
              sub_price_view = sub_price.toFixed(2);
            }
            sub_cross_price = ((lowestprice * variantTitleValue)- parseFloat(sub_price));
            console.log('sub_price_view',sub_price_view);
           // console.log(index+' s- '+variantTitleValue,( (sub_price)));
            switch (od_producthandle) {
              case 'glow-powder':
                if(val.option2.match(/\d+/)[0] == '12')
                {
                    sellingplan = val.selling_plan_allocations[2].selling_plan_id
                }
                else if (val.option2.match(/\d+/)[0] == '6')
                {
                    sellingplan = val.selling_plan_allocations[1].selling_plan_id
                }
                else if (val.option2.match(/\d+/)[0] == '2')
                {
                    sellingplan = val.selling_plan_allocations[0].selling_plan_id
                }
                sub_each_price = ((parseFloat(sub_price))/(variantTitleValue /2));
                break;
              case 'multivitamin':
                if(val.option2.match(/\d+/)[0] == '1')
                {
                    sellingplan = val.selling_plan_allocations[0].selling_plan_id
                }
                else if (val.option2.match(/\d+/)[0] == '3')
                {
                    sellingplan = val.selling_plan_allocations[1].selling_plan_id
                }
                else if (val.option2.match(/\d+/)[0] == '6')
                {
                    sellingplan = val.selling_plan_allocations[2].selling_plan_id
                }
                sub_each_price = ((parseFloat(sub_price))/(variantTitleValue));
                break;
              case 'biotin':
                if(val.option1.match(/\d+/)[0] == '1')
                {
                    sellingplan = val.selling_plan_allocations[0].selling_plan_id
                }
                else if (val.option1.match(/\d+/)[0] == '3')
                {
                    sellingplan = val.selling_plan_allocations[1].selling_plan_id
                }
                else if (val.option1.match(/\d+/)[0] == '6')
                {
                    sellingplan = val.selling_plan_allocations[2].selling_plan_id
                }
                sub_each_price = ((parseFloat(sub_price))/(variantTitleValue));
                break;
              default:
                if(val.option1.match(/\d+/)[0] == '1')
                {
                    sellingplan = val.selling_plan_allocations[0].selling_plan_id
                }
                else if (val.option1.match(/\d+/)[0] == '3')
                {
                    sellingplan = val.selling_plan_allocations[1].selling_plan_id
                }
                else if (val.option1.match(/\d+/)[0] == '6')
                {
                    sellingplan = val.selling_plan_allocations[2].selling_plan_id
                }
                sub_each_price = ((parseFloat(sub_price))/(variantTitleValue));
                /*
                var otp_cross_price = Math.round(otp_total-(val.price/100));
                if(variantTitleValue == 1){
                    otp_each_price = (val.price/100);
                    sub_each_price = (parseFloat(sub_price));
                }
                else if (variantTitleValue == 3){
                    otp_each_price = ((val.price/100)/3);
                    sub_each_price = (parseFloat(sub_price)/3);
                }
                else if (variantTitleValue == 6){
                    otp_each_price = ((val.price/100)/6);
                    sub_each_price = (parseFloat(sub_price)/6);
                }
                sub_cross_price = ((lowestprice * variantTitleValue)- parseFloat(sub_price));*/
            }
        }
        if(od_filter == '')
        {
          flavour = {id:val.id, title:val.title, supply:val.option1, sellingplan:sellingplan, price: val.price,comp_price: val.compare_at_price, subid: subID, sub_price: sub_price_view,otp_cross_price:otp_cross_price,otp_each_price: otp_each_price, sub_each_price: sub_each_price, sub_cross_price: sub_cross_price};
          supplydata.push(flavour);
        }
        else if(od_filter == val.option1)
        {
          flavour[val.option1] = {id:val.id, title:val.title, supply:val.option2, sellingplan:sellingplan, price: val.price,comp_price: val.compare_at_price, subid: subID, sub_price: sub_price_view,otp_cross_price:otp_cross_price,otp_each_price: otp_each_price, sub_each_price: sub_each_price, sub_cross_price: sub_cross_price};
          supplydata.push(flavour);
        }
        
        });
    return supplydata;
}
});

 $(document).on('click touchstart','#confirm-request', function () {
 //$('#confirm-request').click(function() {
    // Send AJAX request to send-quote.php

$.ajax({
type: 'POST',
url: '/cart/change.js',
// describe the data you want to change here

data:       {
  'line': 2,
  'quantity': 0
},
dataType: 'json',
success: function() {

var sellingplan = $('.offer-part.active').attr('data-sellingplan');
    var variationid = $('.offer-part.active').attr('data-variationid');
    var purchasetype = $(this).attr('rel');
    var payloaddata = {};
    payloaddata = {quantity: 1, id: variationid, properties: {}, selling_plan: sellingplan};


    $.ajax({
        url: '/cart/add.js',
        type: 'POST',
        dataType: 'json',
        data: payloaddata,
    })
    .done(function(res) {
        console.log("success");


    //  $('#confirmation-message').addClass("hidden");
       // $('#confirmation-message').removeClass("show");
      
    })
    .fail(function(res) {
        console.log("error");
        console.log(res);
    })
    .always(function(res) {
        console.log("complete");
        //console.log(res);
    });

  
},
error: function(XMLHttpRequest, textStatus) {

}
});




  });
 
  // Handle cancellation
  $('#cancel-request').click(function() {
    // $('#confirmation-message').hide();
    //   $('.overlays').hide();

    $('#confirmation-message').addClass("hidden");
        $('#confirmation-message').removeClass("show");
  });
$('.close-btn').click(function() {
    // $('#confirmation-message').hide();
    //   $('.overlays').hide();

    $('#confirmation-message').addClass("hidden");
        $('#confirmation-message').removeClass("show");
  });